import React from "react";

const SkyLogo = ({ className = "h-10 w-auto", fill = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 271 32"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
    >
      <path
        d="M165.75 31.8626C164.056 31.8626 162.805 30.5005 162.805 28.7063C162.805 26.912 164.056 25.678 165.75 25.678H169.037V26.7591H165.75C164.665 26.7591 163.864 27.5842 163.864 28.7578C163.864 29.9314 164.658 30.7814 165.75 30.7814H169.037V31.8626H165.75Z"
        fill={fill}
      />
      <path
        d="M176.055 31.8618L175.146 30.3041H172.276L172.776 29.4274H174.637L173.284 27.1122L170.531 31.86H169.32L172.808 25.9386C172.934 25.7252 173.092 25.5901 173.327 25.5901C173.561 25.5901 173.71 25.7252 173.836 25.9386L177.333 31.86H176.057L176.055 31.8618Z"
        fill={fill}
      />
      <path
        d="M183.451 31.8627L181.915 30.145H179.645V29.1919H182.174C182.934 29.1919 183.334 28.7491 183.334 27.9507C183.334 27.1523 182.899 26.7593 182.174 26.7593H178.869V31.8645H177.818V25.6799H182.174C183.559 25.6799 184.377 26.5566 184.377 27.9347C184.377 28.9554 183.909 29.6791 183.126 29.985L184.953 31.8645H183.451V31.8627Z"
        fill={fill}
      />
      <path
        d="M185.338 31.8626V30.7814H189.886C190.454 30.7814 190.77 30.4578 190.77 29.9741C190.77 29.446 190.453 29.1739 189.886 29.1739H187.099C185.956 29.1739 185.246 28.4342 185.246 27.4135C185.246 26.3928 185.905 25.678 187.115 25.678H191.471V26.7591H187.115C186.631 26.7591 186.347 27.0472 186.347 27.5166C186.347 27.9861 186.64 28.2653 187.106 28.2653H189.884C191.111 28.2653 191.77 28.8521 191.77 30.0523C191.77 31.0908 191.152 31.8643 189.884 31.8643H185.337L185.338 31.8626Z"
        fill={fill}
      />
      <path
        d="M201.127 31.8618L200.219 30.3041H197.348L197.849 29.4274H199.709L198.356 27.1122L195.603 31.86H194.393L197.881 25.9386C198.007 25.7252 198.165 25.5901 198.399 25.5901C198.633 25.5901 198.782 25.7252 198.908 25.9386L202.405 31.86H201.129L201.127 31.8618Z"
        fill={fill}
      />
      <path
        d="M207.795 25.678H208.83V29.133C208.83 31.0464 207.903 31.9479 205.551 31.9479C203.199 31.9479 202.279 31.0464 202.279 29.133V25.678H203.373V29.133C203.373 30.3742 203.916 30.8845 205.585 30.8845C207.253 30.8845 207.796 30.3742 207.796 29.133V25.678H207.795Z"
        fill={fill}
      />
      <path
        d="M212.392 31.8626C210.699 31.8626 209.447 30.5005 209.447 28.7063C209.447 26.912 210.699 25.678 212.392 25.678H215.68V26.7591H212.392C211.308 26.7591 210.507 27.5842 210.507 28.7578C210.507 29.9314 211.301 30.7814 212.392 30.7814H215.68V31.8626H212.392Z"
        fill={fill}
      />
      <path
        d="M218.318 31.8624V26.7572H216.014V25.676H221.68V26.7572H219.376V31.8624H218.316H218.318Z"
        fill={fill}
      />
      <path
        d="M222.275 31.8626V25.678H223.335V31.8626H222.275Z"
        fill={fill}
      />
      <path
        d="M227.048 31.8626C225.355 31.8626 224.104 30.5005 224.104 28.7063C224.104 26.912 225.355 25.678 227.048 25.678H228.525C230.277 25.678 231.495 26.912 231.495 28.7063C231.495 30.5005 230.253 31.8626 228.525 31.8626H227.048ZM228.525 30.7814C229.644 30.7814 230.435 29.9225 230.435 28.7578C230.435 27.5931 229.642 26.7591 228.525 26.7591H227.048C225.964 26.7591 225.163 27.5842 225.163 28.7578C225.163 29.9314 225.957 30.7814 227.048 30.7814H228.525Z"
        fill={fill}
      />
      <path
        d="M233.174 27.3372V31.8627H232.164V26.2471C232.164 25.847 232.372 25.5999 232.707 25.5999C232.865 25.5999 232.998 25.6585 233.158 25.8203L237.44 30.1503V25.6247H238.45V31.2919C238.45 31.6991 238.233 31.9391 237.924 31.9391C237.749 31.9391 237.591 31.8627 237.44 31.7097L233.176 27.3372H233.174Z"
        fill={fill}
      />
      <path
        d="M239.307 31.8626V30.7814H243.855C244.423 30.7814 244.739 30.4578 244.739 29.9741C244.739 29.446 244.421 29.1739 243.855 29.1739H241.068C239.925 29.1739 239.215 28.4342 239.215 27.4135C239.215 26.3928 239.873 25.678 241.084 25.678H245.44V26.7591H241.084C240.599 26.7591 240.315 27.0472 240.315 27.5166C240.315 27.9861 240.608 28.2653 241.075 28.2653H243.853C245.08 28.2653 245.738 28.8521 245.738 30.0523C245.738 31.0908 245.121 31.8643 243.853 31.8643H239.305L239.307 31.8626Z"
        fill={fill}
      />
      <path
        d="M248.771 31.8626V25.678H249.831V30.7832H253.912V31.8643H248.771V31.8626Z"
        fill={fill}
      />
      <path
        d="M256.793 31.8626V25.678H257.853V30.7832H261.934V31.8643H256.793V31.8626Z"
        fill={fill}
      />
      <path
        d="M267.582 31.8626C265.888 31.8626 264.637 30.5005 264.637 28.7063C264.637 26.912 265.888 25.678 267.582 25.678H270.869V26.7591H267.582C266.497 26.7591 265.696 27.5842 265.696 28.7578C265.696 29.9314 266.49 30.7814 267.582 30.7814H270.869V31.8626H267.582Z"
        fill={fill}
      />
      <path
        d="M11.9558 9.6883L11.7907 10.8246V12.3449C11.7907 13.6252 10.5641 14.2689 8.09309 14.2689H4.06356C3.25056 14.2689 2.85293 14.5428 2.85293 15.0887V16.5112L1.21094 15.7786V14.7953C1.21094 13.8653 2.1553 13.2856 3.66416 13.2856H5.98602C5.65407 12.914 5.48899 12.5192 5.48899 12.1155C5.48899 11.3065 5.85289 10.661 6.58247 10.1684C7.31204 9.67585 8.30611 9.43579 9.5842 9.43579C10.3795 9.43579 11.1765 9.52292 11.9558 9.68652V9.6883ZM10.2161 10.9028L10.083 10.268C9.81851 10.2129 9.53627 10.1915 9.2203 10.1915C7.82682 10.1915 7.13098 10.7606 7.13098 11.9075C7.13098 12.8268 7.61204 13.2856 8.5564 13.2856C9.73331 13.2856 10.3298 12.793 10.3298 11.8204C10.3298 11.5696 10.296 11.262 10.2144 10.901L10.2161 10.9028Z"
        fill={fill}
      />
      <path
        d="M25.7019 9.6883L25.5368 10.8246V12.3449C25.5368 13.6252 24.3102 14.2689 21.8392 14.2689H17.8097C16.9967 14.2689 16.599 14.5428 16.599 15.0887V16.5112L14.957 15.7786V14.7953C14.957 13.8653 15.9014 13.2856 17.4103 13.2856H19.7321C19.4002 12.914 19.2351 12.5192 19.2351 12.1155C19.2351 11.3065 19.599 10.661 20.3286 10.1684C21.0581 9.67585 22.0522 9.43579 23.3303 9.43579C24.1255 9.43579 24.9226 9.52292 25.7019 9.68652V9.6883ZM23.9605 10.9028L23.8273 10.268C23.5628 10.2129 23.2806 10.1915 22.9646 10.1915C21.5711 10.1915 20.8753 10.7606 20.8753 11.9075C20.8753 12.8268 21.3564 13.2856 22.3007 13.2856C23.4776 13.2856 24.0741 12.793 24.0741 11.8204C24.0741 11.5696 24.0403 11.262 23.9587 10.901L23.9605 10.9028Z"
        fill={fill}
      />
      <path
        d="M35.0368 12.0939V13.2746L35.2853 14.2704H28.7031L29.1345 13.2871H33.3291L33.3788 13.0577V11.909C33.3788 11.3737 33.2137 10.9576 32.8977 10.6411C32.5995 10.3673 32.2179 10.225 31.7368 10.225C31.5877 10.225 31.4049 10.2464 31.222 10.3015C31.222 10.193 31.1883 9.98497 31.1386 9.68979C31.1883 9.68979 31.3711 9.67912 31.6534 9.64533C32.6652 9.64533 33.4764 9.87472 34.0906 10.3459C34.7048 10.8047 35.019 11.3844 35.035 12.0957L35.0368 12.0939ZM32.8001 7.89558C32.8001 8.25656 32.3865 8.55174 31.806 8.55174C31.2256 8.55174 30.7782 8.2779 30.7782 7.89558C30.7782 7.51327 31.2256 7.22876 31.806 7.22876C32.3368 7.22876 32.8001 7.51327 32.8001 7.89558Z"
        fill={fill}
      />
      <path
        d="M51.2844 12.6722C51.2844 13.668 50.356 14.269 48.8471 14.269H41.4023C40.4579 14.269 39.6946 14.0503 39.1301 13.6235C38.5656 13.1861 38.2852 12.6171 38.2852 11.9058C38.2852 11.3599 38.4999 10.846 38.9313 10.3534H40.4064C39.8916 10.8353 39.6271 11.2834 39.6271 11.6889C39.6271 12.7487 40.291 13.2857 41.5993 13.2857H48.43C49.243 13.2857 49.6566 13.0012 49.6566 12.4215V11.3385L49.3424 9.9391L51.2826 9.64392V12.674L51.2844 12.6722ZM44.5194 9.6866C44.5194 10.0476 44.0721 10.3428 43.5253 10.3428C42.9449 10.3428 42.5135 10.0689 42.5135 9.67593C42.5135 9.31495 42.9449 9.01978 43.5253 9.01978C44.0721 9.01978 44.5194 9.30429 44.5194 9.6866ZM47.1732 9.6866C47.1732 10.0476 46.7259 10.3428 46.1791 10.3428C45.5987 10.3428 45.1673 10.0689 45.1673 9.67593C45.1673 9.31495 45.5987 9.01978 46.1791 9.01978C46.7259 9.01978 47.1732 9.30429 47.1732 9.6866Z"
        fill={fill}
      />
      <path
        d="M54.8663 7.20515L54.6835 8.65971V14.2699H53.0415V8.67038L52.793 7.31362L54.8645 7.20337L54.8663 7.20515Z"
        fill={fill}
      />
      <path
        d="M58.9475 13.8109C58.9475 15.2868 57.7546 16.2488 55.3831 16.6863L55.0352 16.2595C56.56 15.943 57.3233 15.2424 57.3233 14.1488L57.3073 11.4032L56.9754 9.938L58.9475 9.64282V13.8091V13.8109Z"
        fill={fill}
      />
      <path
        d="M64.4827 14.2704H63.1886C61.6797 14.2704 60.7354 13.657 60.7354 12.6416V8.92338L60.4531 7.52394L62.3933 7.22876V12.3909C62.3933 12.9919 62.791 13.2871 63.5862 13.2871H64.4809V14.2704H64.4827Z"
        fill={fill}
      />
      <path
        d="M65.9771 16.0302C65.9771 16.3699 65.5298 16.6864 64.9493 16.6864C64.4186 16.6864 63.9375 16.4126 63.9375 16.0196C63.9375 15.6586 64.4186 15.3634 64.9493 15.3634C65.4801 15.3634 65.9771 15.6479 65.9771 16.0302ZM70.454 14.2698H69.2114C68.5475 14.2698 68.0008 14.1614 67.5872 13.9426C67.1558 14.1614 66.625 14.2698 65.9949 14.2698H64.0227V13.2865H65.5653C66.3783 13.2865 66.7759 13.002 66.7759 12.4223V11.2967L66.444 9.88656L68.4161 9.60205V12.4241C68.4161 13.0037 68.8138 13.2883 69.6268 13.2883H70.4558V14.2716L70.454 14.2698ZM68.6132 16.0302C68.6132 16.3699 68.1818 16.6864 67.6014 16.6864C67.0546 16.6864 66.6073 16.4126 66.6073 16.0196C66.6073 15.6586 67.0546 15.3634 67.6014 15.3634C68.1481 15.3634 68.6132 15.6479 68.6132 16.0302Z"
        fill={fill}
      />
      <path
        d="M84.5802 14.2697H83.7015C83.0376 14.2697 82.4908 14.1612 82.0435 13.9425C81.6299 14.1612 81.0991 14.2697 80.469 14.2697C79.5903 14.2697 78.8607 14.0616 78.2465 13.6455C77.7992 14.0616 77.1353 14.2697 76.2406 14.2697C75.3957 14.2697 74.6483 14.051 74.0022 13.6242C73.9188 13.7007 73.8034 13.7771 73.688 13.8536C73.2407 14.1274 72.6602 14.2697 71.9146 14.2697H69.9922V13.2864H71.517C72.3123 13.2864 72.7099 13.0018 72.7099 12.4221L72.7436 10.3114L74.3679 10.0714V12.9254C74.7815 13.1761 75.2625 13.297 75.811 13.297C76.5903 13.297 76.988 13.0125 76.988 12.4328V10.3114L78.6299 10.0714V12.8934C79.0436 13.1672 79.5086 13.297 80.0554 13.297C80.8346 13.297 81.2323 13.0125 81.2323 12.4328V11.3606L80.9181 9.938L82.8902 9.64282V12.431C82.8902 13.0001 83.2879 13.2846 84.0831 13.2846H84.5802V14.2679V14.2697Z"
        fill={fill}
      />
      <path
        d="M89.703 12.641C89.703 13.6581 88.7586 14.2698 87.232 14.2698H84.1309V13.2865H86.8326C87.6456 13.2865 88.0432 12.9913 88.0432 12.3903V8.9121L87.761 7.4682L89.7012 7.16235V12.641H89.703Z"
        fill={fill}
      />
      <path
        d="M93.2843 7.20515L93.1014 8.65971V14.2699H91.4594V8.67038L91.2109 7.31362L93.2825 7.20337L93.2843 7.20515Z"
        fill={fill}
      />
      <path
        d="M102.619 12.0934V13.2741L102.867 14.2699H96.2852L96.7165 13.2865H100.911L100.961 13.0571V11.9084C100.961 11.3732 100.796 10.9571 100.48 10.6406C100.182 10.3667 99.7999 10.2245 99.3188 10.2245C99.1697 10.2245 98.9869 10.2458 98.8041 10.3009C98.8041 10.1925 98.7703 9.98441 98.7206 9.68923C98.7703 9.68923 98.9532 9.67856 99.2354 9.64478C100.247 9.64478 101.058 9.87416 101.673 10.3454C102.287 10.8042 102.601 11.3839 102.617 12.0951L102.619 12.0934Z"
        fill={fill}
      />
      <path
        d="M106.448 7.20503L106.265 8.65959V14.2698H104.624V8.67026L104.375 7.3135L106.447 7.20337L106.448 7.20503Z"
        fill={fill}
      />
      <path
        d="M112.669 14.2704H111.343C111.044 14.2704 110.762 14.2491 110.514 14.194C110.315 15.4618 109.138 16.294 106.965 16.687L106.617 16.2602C108.142 15.9437 108.905 15.2431 108.905 14.1495L108.889 11.404L108.557 9.93874L110.53 9.64356V12.3766C110.53 12.9777 110.927 13.2853 111.74 13.2853H112.669V14.2687V14.2704ZM110.396 7.89558C110.396 8.25656 109.965 8.55174 109.385 8.55174C108.838 8.55174 108.391 8.2779 108.391 7.89558C108.391 7.51327 108.838 7.22876 109.385 7.22876C109.931 7.22876 110.396 7.51327 110.396 7.89558Z"
        fill={fill}
      />
      <path
        d="M122.996 14.2705H121.803C121.189 14.2705 120.66 14.162 120.229 13.9309C119.416 14.5657 118.438 14.8822 117.295 14.8822C116.366 14.8822 115.653 14.6084 115.173 14.0731C114.809 14.2047 114.394 14.2705 113.931 14.2705H112.207V13.2872H113.483C114.229 13.2872 114.611 13.0471 114.627 12.5652C114.71 11.0004 116.251 10.0491 118.771 10.0491C119.584 10.0491 120.38 10.1362 121.175 10.2998L120.976 11.4378V12.4212C120.976 13.0009 121.374 13.2854 122.187 13.2854H123V14.2687L122.996 14.2705ZM119.331 13.4952V11.4947L119.197 10.8813C118.949 10.8261 118.683 10.8048 118.402 10.8048C117.026 10.8048 116.331 11.3738 116.331 12.5225C116.331 13.4419 116.927 13.9878 117.724 13.9878C118.321 13.9878 118.851 13.8242 119.332 13.4952H119.331Z"
        fill={fill}
      />
      <path
        d="M128.119 12.641C128.119 13.6581 127.175 14.2698 125.648 14.2698H122.547V13.2865H125.249C126.062 13.2865 126.459 12.9913 126.459 12.3903V8.9121L126.177 7.4682L128.117 7.16235V12.641H128.119Z"
        fill={fill}
      />
      <path
        d="M0.914062 31.8627V21.2717H2.73002V31.8627H0.914062ZM9.48081 31.8627L3.66018 27.2002C3.34598 26.9531 3.28918 26.7184 3.28918 26.4285C3.28918 26.1084 3.37439 25.8755 3.74716 25.5839L9.2536 21.2717H12.0423L5.23471 26.4445L12.2571 31.8645H9.48259L9.48081 31.8627Z"
        fill="url(#paint0_linear_231_451)"
      />
      <path
        d="M13.1465 31.9071V21.2717H14.9624V31.9071H13.1465ZM21.5126 31.9071V27.3034H16.2778V25.6568H21.5126V21.2717H23.3286V31.9071H21.5126Z"
        fill="url(#paint1_linear_231_451)"
      />
      <path
        d="M35.6901 31.862L34.1316 29.1965H29.2109L30.0683 27.6957H33.2582L30.9399 23.7321L26.2198 31.862H24.1465L30.1251 21.7227C30.3399 21.3582 30.6115 21.1252 31.0109 21.1252C31.4103 21.1252 31.6695 21.3582 31.8842 21.7227L37.8771 31.862H35.6883H35.6901Z"
        fill="url(#paint2_linear_231_451)"
      />
      <path
        d="M40.1979 31.8625V23.1209H36.25V21.2698H45.9617V23.1209H42.0138V31.8625H40.1979Z"
        fill="url(#paint3_linear_231_451)"
      />
      <path
        d="M61.6434 31.862L60.0849 29.1965H55.1642L56.0234 27.6957H59.2133L56.895 23.7321L52.1749 31.862H50.1016L56.0802 21.7227C56.295 21.3582 56.5666 21.1252 56.9677 21.1252C57.3689 21.1252 57.6263 21.3582 57.8411 21.7227L63.8339 31.862H61.6452H61.6434Z"
        fill="url(#paint4_linear_231_451)"
      />
      <path
        d="M64.6641 31.8627V21.2717H66.48V30.0134H73.474V31.8627H64.6641Z"
        fill="url(#paint5_linear_231_451)"
      />
      <path
        d="M77.8555 31.8627V30.0134H81.6596C84.0915 30.0134 85.0785 29.0958 85.0785 27.042V21.2717H86.8944V27.042C86.8944 30.3192 85.2773 31.8645 81.6596 31.8645H77.8555V31.8627Z"
        fill="url(#paint6_linear_231_451)"
      />
      <path
        d="M98.2097 31.862L96.6511 29.1965H91.7304L92.5878 27.6957H95.7777L93.4594 23.7321L88.7394 31.862H86.666L92.6446 21.7227C92.8594 21.3582 93.131 21.1252 93.5304 21.1252C93.9298 21.1252 94.189 21.3582 94.4038 21.7227L100.397 31.862H98.2079H98.2097Z"
        fill="url(#paint7_linear_231_451)"
      />
      <path
        d="M101.932 31.8627C101.389 31.8627 100.902 31.5426 100.902 30.9149C100.902 30.6393 101.032 30.3761 101.273 30.1289L108.182 23.0339H101.03V21.2717H110.128C110.657 21.2717 111.157 21.5918 111.157 22.2195C111.157 22.4951 111.029 22.7583 110.786 23.0055L103.877 30.1005H111.115V31.8627H101.932Z"
        fill="url(#paint8_linear_231_451)"
      />
      <path
        d="M112.422 31.8627V21.2717H121.704V23.1228H114.224V30.0134H121.718V31.8627H112.422ZM115.553 27.2589V25.6994H121.317V27.2589H115.553Z"
        fill="url(#paint9_linear_231_451)"
      />
      <path
        d="M122.992 31.8627V21.2717H132.274V23.1228H124.794V30.0134H132.289V31.8627H122.992ZM126.123 27.2589V25.6994H131.887V27.2589H126.123Z"
        fill="url(#paint10_linear_231_451)"
      />
      <path
        d="M143.221 31.8627L140.591 28.9198H136.7V27.2874H141.033C142.336 27.2874 143.021 26.5299 143.021 25.1606C143.021 23.7914 142.277 23.1211 141.033 23.1211H135.368V31.8627H133.566V21.2717H141.033C143.408 21.2717 144.808 22.7725 144.808 25.1322C144.808 26.8802 144.008 28.1196 142.662 28.6441L145.795 31.8645H143.221V31.8627Z"
        fill="url(#paint11_linear_231_451)"
      />
      <path
        d="M157.296 31.862L155.737 29.1965H150.817L151.676 27.6957H154.866L152.547 23.7321L147.827 31.862H145.754L151.733 21.7227C151.947 21.3582 152.219 21.1252 152.62 21.1252C153.021 21.1252 153.279 21.3582 153.493 21.7227L159.486 31.862H157.298H157.296Z"
        fill="url(#paint12_linear_231_451)"
      />
      <path
        d="M146.113 9.26155C146.113 10.7481 145.449 11.952 144.157 12.8926C142.863 13.812 141.105 14.2707 138.95 14.2707C136.795 14.2707 135.203 13.8333 133.943 12.9584C132.716 12.0622 132.086 10.8815 132.086 9.41625C132.086 7.95101 132.716 6.66004 133.976 5.71937C135.237 4.77871 137.028 4.29681 139.314 4.29681C143.559 4.29681 146.111 6.13369 146.111 9.26155H146.113ZM138.652 1.51749C138.652 2.23944 137.757 2.8298 136.597 2.8298C135.535 2.8298 134.575 2.28389 134.575 1.49615C134.575 0.774201 135.537 0.183838 136.597 0.183838C137.656 0.183838 138.652 0.752862 138.652 1.51749ZM142.566 9.26155C142.566 6.94277 141.439 5.78339 139.185 5.78339C136.797 5.78339 135.604 6.94277 135.604 9.26155C135.604 11.5803 136.765 12.7824 139.053 12.7824C141.341 12.7824 142.568 11.6017 142.568 9.26155H142.566ZM143.924 1.51749C143.924 2.23944 143.062 2.8298 141.902 2.8298C140.809 2.8298 139.847 2.28389 139.847 1.49615C139.847 0.774201 140.809 0.183838 141.902 0.183838C142.996 0.183838 143.924 0.752862 143.924 1.51749Z"
        fill="url(#paint13_linear_231_451)"
      />
      <path
        d="M158.549 14.2698H155.897C155.3 14.2698 154.736 14.2253 154.239 14.1169C153.841 16.6544 151.487 18.317 147.144 19.1029L146.414 18.2494C149.497 17.6146 151.022 16.2151 151.022 14.028L150.989 8.53866L150.325 5.60818L154.271 5.01782V10.4858C154.271 11.6878 155.066 12.3013 156.692 12.3013H158.549V14.2698Z"
        fill="url(#paint14_linear_231_451)"
      />
      <path
        d="M161.402 17.7927C161.402 18.4702 160.507 19.105 159.346 19.105C158.285 19.105 157.324 18.5574 157.324 17.7714C157.324 17.0494 158.286 16.4591 159.346 16.4591C160.406 16.4591 161.402 17.0281 161.402 17.7945V17.7927ZM167.602 11.0996C167.602 13.0467 165.712 14.2719 162.694 14.2719H157.621V12.3034H161.899C163.523 12.3034 164.32 11.7344 164.32 10.575V8.40917L163.755 5.61028L167.602 5.04126V11.0996ZM166.674 17.7927C166.674 18.4702 165.811 19.105 164.652 19.105C163.558 19.105 162.596 18.5574 162.596 17.7714C162.596 17.0494 163.558 16.4591 164.652 16.4591C165.745 16.4591 166.674 17.0281 166.674 17.7945V17.7927Z"
        fill="url(#paint15_linear_231_451)"
      />
      <path
        d="M180.402 14.269H177.75C177.153 14.269 176.589 14.2245 176.092 14.116C175.694 16.6535 173.34 18.3161 168.997 19.1021L168.301 18.2486C171.352 17.6137 172.877 16.2143 172.877 14.0271L172.843 8.53782L172.179 5.60735L176.126 5.01698V10.4849C176.126 11.687 176.921 12.3005 178.547 12.3005H180.404V14.269H180.402ZM175.859 1.51749C175.859 2.23944 174.997 2.8298 173.837 2.8298C172.744 2.8298 171.847 2.28389 171.847 1.51749C171.847 0.751083 172.742 0.183838 173.837 0.183838C174.933 0.183838 175.859 0.752862 175.859 1.51749Z"
        fill="url(#paint16_linear_231_451)"
      />
      <path
        d="M200.165 14.2689H179.475V12.3005H193.8C193.005 11.0984 191.909 9.85012 190.484 8.6036C188.661 6.9641 187.035 6.15324 185.675 6.15324C184.681 6.15324 184.182 6.56934 184.182 7.37842C184.182 7.7714 184.347 8.25329 184.647 8.84366L181.198 9.10505C181.562 6.24037 183.818 4.51196 186.737 4.51196C188.991 4.51196 191.279 5.47397 193.567 7.39798C195.325 8.90767 196.718 10.5472 197.679 12.2969H200.165V14.2654V14.2689ZM191.577 17.7916C191.577 18.469 190.748 19.1039 189.587 19.1039C188.427 19.1039 187.532 18.5562 187.532 17.7702C187.532 17.0483 188.427 16.4579 189.587 16.4579C190.649 16.4579 191.577 17.0269 191.577 17.7933V17.7916Z"
        fill="url(#paint17_linear_231_451)"
      />
      <path
        d="M210.414 11.0122C210.414 13.0465 208.524 14.2716 205.474 14.2716H199.273V12.3032H204.679C206.303 12.3032 207.1 11.7128 207.1 10.509V3.55443L206.535 0.66841L210.416 0.0549316V11.014L210.414 11.0122Z"
        fill="url(#paint18_linear_231_451)"
      />
      <path
        d="M217.577 0.140869L217.213 3.05V14.2704H213.931V3.07134L213.434 0.359588L217.579 0.140869H217.577Z"
        fill="url(#paint19_linear_231_451)"
      />
      <path
        d="M252.99 14.269H223.578L223.976 11.9947L227.789 12.3006C227.755 12.1263 227.723 9.28298 227.723 3.77056L227.226 1.08014L231.405 0.840088L231.041 3.72611V10.0689C232.003 8.88822 233.428 7.79462 235.285 6.8095C237.573 5.56298 239.762 4.94951 241.883 4.94951C244.237 4.94951 246.128 5.29981 247.62 6.02176C249.113 6.74371 249.875 7.70572 249.875 8.95223V12.2988H252.992V14.2673L252.99 14.269ZM246.525 12.3006V9.30432C246.525 7.6417 244.734 6.81128 241.187 6.81128C239.297 6.81128 237.142 7.55457 234.788 9.04292C232.798 10.2894 231.572 11.3617 231.074 12.3024H246.527L246.525 12.3006Z"
        fill="url(#paint20_linear_231_451)"
      />
      <path
        d="M270.998 14.269H252.064V12.3005H266.39C265.594 11.0984 264.499 9.85013 263.074 8.60361C261.251 6.96411 259.625 6.15325 258.265 6.15325C257.271 6.15325 256.772 6.56935 256.772 7.37843C256.772 7.77142 256.937 8.25331 257.237 8.84367L253.788 9.10506C254.152 6.24039 256.408 4.51198 259.326 4.51198C261.847 4.51198 264.434 5.73715 267.052 8.20885C269.473 10.4832 270.765 12.4961 270.998 14.2672V14.269ZM262.41 1.51749C262.41 2.23944 261.515 2.8298 260.354 2.8298C259.293 2.8298 258.364 2.28389 258.364 1.51749C258.364 0.751083 259.293 0.183838 260.354 0.183838C261.515 0.183838 262.41 0.752862 262.41 1.51749Z"
        fill="url(#paint21_linear_231_451)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_231_451"
          x1="-11.6946"
          y1="27.8688"
          x2="45.4334"
          y2="23.8143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_231_451"
          x1="-11.636"
          y1="28.717"
          x2="45.4938"
          y2="24.6625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_231_451"
          x1="-11.5601"
          y1="29.7691"
          x2="45.5679"
          y2="25.7145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_231_451"
          x1="-11.5328"
          y1="30.175"
          x2="45.597"
          y2="26.1205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_231_451"
          x1="-11.4296"
          y1="31.6077"
          x2="45.7002"
          y2="27.5532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_231_451"
          x1="-11.3804"
          y1="32.2966"
          x2="45.7476"
          y2="28.242"
          gradientUnits="userSpaceOnUse"
        >
          i
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_231_451"
          x1="-11.3072"
          y1="33.3244"
          x2="45.8226"
          y2="29.2698"
          gradientUnits="userSpaceOnUse"
        >
          i
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_231_451"
          x1="-11.2463"
          y1="34.1986"
          x2="45.8835"
          y2="30.144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_231_451"
          x1="-11.1968"
          y1="34.9176"
          x2="45.9331"
          y2="30.8631"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_231_451"
          x1="-11.1374"
          y1="35.6965"
          x2="45.9906"
          y2="31.6419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_231_451"
          x1="-11.0882"
          y1="36.4469"
          x2="46.0416"
          y2="32.3923"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_231_451"
          x1="-11.0246"
          y1="37.2986"
          x2="46.1035"
          y2="33.2441"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_231_451"
          x1="-10.9505"
          y1="38.3844"
          x2="46.1793"
          y2="34.3299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_231_451"
          x1="298.426"
          y1="-3.97181"
          x2="232.362"
          y2="0.623202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_231_451"
          x1="298.821"
          y1="1.7246"
          x2="232.757"
          y2="6.31783"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_231_451"
          x1="298.898"
          y1="2.80962"
          x2="232.832"
          y2="7.40464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_231_451"
          x1="298.755"
          y1="0.75286"
          x2="232.69"
          y2="5.34786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_231_451"
          x1="298.985"
          y1="4.06919"
          x2="232.921"
          y2="8.66421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_231_451"
          x1="298.76"
          y1="0.837337"
          x2="232.696"
          y2="5.43058"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_231_451"
          x1="298.806"
          y1="1.48874"
          x2="232.742"
          y2="6.08375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_231_451"
          x1="298.95"
          y1="3.56785"
          x2="232.886"
          y2="8.16286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_231_451"
          x1="299.041"
          y1="4.89429"
          x2="232.977"
          y2="9.48929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SkyLogo;
